module.exports = __webpack_public_path__ + "img/hero-bg.8100f251.jpg";